import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoConsultaLicitacaoCovid: [],
    removeAguardandoAberturaConsultaLicitacaoCovid: [],
    removeTipoCompraConsultaLicitacaoCovid: [],
    removeExercicioLicitacaoConsultaLicitacaoCovid: [],
    removeNumeroLicitacaoConsultaLicitacaoCovid: [],
    removeModalidadeConsultaLicitacaoCovid: [],
    removeObjetoConsultaLicitacaoCovid: [],
    removeDataAberturaInicialConsultaLicitacaoCovid: [],
    removeDataAberturaFinalConsultaLicitacaoCovid: [],
    removeObjetoLicitacaoConsultaLicitacaoCovid: [],
    removeStatusConsultaLicitacaoCovid: [],
    removeSituacaoPesquisaConsultaLicitacaoCovid: [],
    setMostraAplicarFiltroConsultaLicitacaoCovid: [],
    limpaFiltroConsultaLicitacaoCovid: [],
    aplicarFiltroConsultaLicitacaoCovid: ['filtro'],
})

const INITIAL_STATE = {
    administracoes: [],
    aguardandoAbertura: '',
    tipoCompra: '',
    exercicioLicitacao: '',
    numeroLicitacao: '',
    modalidade: [],
    objeto: '',
    dataAberturaInicial: '',
    dataAberturaFinal: '',
    objetoLicitacao: [],
    situacaoPesquisa: '',
    mostraAplicarFiltro: false,
    status: '',
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracoes.splice(state.administracoes.indexOf(action.administracoes), 1)
    state.administracoes = Array.from(state.administracoes)
    return { ...state, mostraAplicarFiltro: true }
}

const removeObjetoLicitacao = (state = INITIAL_STATE, action) => {
    state.objetoLicitacao.splice(state.objetoLicitacao.indexOf(action.objetoLicitacao), 1)
    state.objetoLicitacao = Array.from(state.objetoLicitacao)
    return { ...state, mostraAplicarFiltro: true }
}

const removeAguardandoAbertura = (state = INITIAL_STATE, action) => {
    return { ...state, aguardandoAbertura: '', mostraAplicarFiltro: true }
}

const removeTipoCompra = (state = INITIAL_STATE, action) => {
    return { ...state, tipoCompra: '', mostraAplicarFiltro: true }
}

const removeExercicioLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, exercicioLicitacao: '', mostraAplicarFiltro: true }
}

const removeNumeroLicitacao = (state = INITIAL_STATE, action) => {
    return { ...state, numeroLicitacao: '', mostraAplicarFiltro: true }
}

const removeModalidade = (state = INITIAL_STATE, action) => {
    state.modalidade.splice(state.modalidade.indexOf(action.modalidade), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.modalidade = Array.from(state.modalidade)
    return { ...state, mostraAplicarFiltro: true }
}

const removeObjeto = (state = INITIAL_STATE, action) => {
    return { ...state, objeto: '', mostraAplicarFiltro: true }
}

const removeDataAberturaInicial = (state = INITIAL_STATE, action) => {
    return { ...state, dataAberturaInicial: '', mostraAplicarFiltro: true }
}

const removeDataAberturaFinal = (state = INITIAL_STATE, action) => {
    return { ...state, dataAberturaFinal: '', mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}
const removeSituacaoPesquisaFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, situacaoPesquisa: '', mostraAplicarFiltro: true }
}

const removeStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: '', mostraAplicarFiltro: true }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.REMOVE_ADMINISTRACAO_CONSULTA_LICITACAO_COVID]: removeAdministracao,
    [Types.REMOVE_OBJETO_LICITACAO_CONSULTA_LICITACAO_COVID]: removeObjetoLicitacao,
    [Types.REMOVE_AGUARDANDO_ABERTURA_CONSULTA_LICITACAO_COVID]: removeAguardandoAbertura,
    [Types.REMOVE_TIPO_COMPRA_CONSULTA_LICITACAO_COVID]: removeTipoCompra,
    [Types.REMOVE_EXERCICIO_LICITACAO_CONSULTA_LICITACAO_COVID]: removeExercicioLicitacao,
    [Types.REMOVE_NUMERO_LICITACAO_CONSULTA_LICITACAO_COVID]: removeNumeroLicitacao,
    [Types.REMOVE_MODALIDADE_CONSULTA_LICITACAO_COVID]: removeModalidade,
    [Types.REMOVE_OBJETO_CONSULTA_LICITACAO_COVID]: removeObjeto,
    [Types.REMOVE_DATA_ABERTURA_INICIAL_CONSULTA_LICITACAO_COVID]: removeDataAberturaInicial,
    [Types.REMOVE_DATA_ABERTURA_FINAL_CONSULTA_LICITACAO_COVID]: removeDataAberturaFinal,
    [Types.SET_MOSTRA_APLICAR_FILTRO_CONSULTA_LICITACAO_COVID]: setMostraAplicarFiltro,
    [Types.REMOVE_SITUACAO_PESQUISA_CONSULTA_LICITACAO_COVID]: removeSituacaoPesquisaFiltro,
    [Types.REMOVE_STATUS_CONSULTA_LICITACAO_COVID]: removeStatus,
    [Types.LIMPA_FILTRO_CONSULTA_LICITACAO_COVID]: limpaFiltro,
    [Types.APLICAR_FILTRO_CONSULTA_LICITACAO_COVID]: aplicarFiltro,
})
